import { Drawer, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DRAWER_WIDTH } from '../../const';
import { ComponentsDispatch, RootState } from '../../store';
import { setterDrawer } from '../../store/slices/drawerSlice';
import { setterGantItems } from '../../store/slices/gantItemsSlice';
import { ItemType, ZIndexType } from '../../types';
import GantItemWrapperForm from '../form/gantItemWrapperForm';
import DrawerPanelLabel from './drawerPanelLabel';

const GantDrawerPanel = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const [form] = Form.useForm<ItemType>();

    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);
    const isItemEdit = useSelector<RootState, boolean>((state) => state.gantItems.isItemEdit);
    const [firstModal] = useSelector<RootState, ZIndexType[]>((state) => state.drawer.currentZIndex);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (isItemEdit && currentGantItem) {
            setOpen(true);
        }
    }, [isItemEdit]);

    useEffect(() => {
        if (!currentGantItem || !isItemEdit) {
            setOpen(false);
        }
        dispatch(setterDrawer({ currentZIndex: ['item', 'task'] }));
    }, [currentGantItem, isItemEdit]);

    const onClose = () => {
        dispatch(setterGantItems({ isItemEdit: false, currentGantItem: null }));
        setOpen(false);
    };

    return (
        <Drawer
            title={<DrawerPanelLabel form={form} />}
            onClose={onClose}
            open={open}
            mask={false}
            width={DRAWER_WIDTH}
            zIndex={firstModal === 'item' ? 1102 : 1101}
            styles={{
                body: {
                    padding: 0,
                    display: 'flex',
                    height: '100%',
                    width: '100%',
                    flex: 1,
                },
            }}
        >
            {/* key must be set to guarantee form clears all fields when currentItem changes */}
            {isItemEdit && <GantItemWrapperForm form={form} key={currentGantItem?.id ?? 'not-set-item-form'} />}
        </Drawer>
    );
};

export default GantDrawerPanel;
